import React from "react";

export default function PublicFooter() {
  return (
    <footer className="bg-[#145886] border-t-4 border-[#F37920] py-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mt-12 border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-base text-white/80 text-center md:text-left mb-4 md:mb-0">
            &copy; {new Date().getFullYear()} CA Ronak Patel, Chartered Accountant.
          </p>
          <div className="flex space-x-6">
            <a href="/privacy-policy" className="text-white/80 hover:text-white text-sm">Privacy Policy</a>
            <a href="/terms-of-service" className="text-white/80 hover:text-white text-sm">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
